import { productsData } from '@/mocks/products';

const slugById = new Map<number, string>(
  productsData.map((product) => [product.id, product.slug]),
);

/**
 * Resolve a product detail page path from a product id.
 * Falls back to the products listing page when the product is not in the catalog.
 */
export function getProductPath(id: number): string {
  const slug = slugById.get(id);
  return slug ? `/products/${slug}` : '/products';
}